import React, { useState, useEffect, useRef } from "react";
import "./Votes.scss";
import Items from "../Items/Items.jsx";
import data from "../../static/data/data.json";
import ItemsList from "../ItemsList/ItemsList";
import Loader from "../Loader/Loader";
import ThanksModal from "../ThanksModal/ThanksModal";
import { isMobile, isIos } from "../../static/helper";
import Header from "../Header/Header";
import { GA_Event, virtualPageView } from "../Analytics/Analytics";
import ReCAPTCHA from "react-google-recaptcha";
import { sendVote } from "../../services/sendVote";

const getShuffleData = (array) => {
  Object.keys(array).map((item, i) => {
    for (let i = array[item].length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * i);
      const temp = array[item][i];
      array[item][i] = array[item][j];
      array[item][j] = temp;
    }
  });
  return array;
};

const Votes = (props) => {
  const [isDataShuffled, setisDataShuffled] = useState(false);
  const [dataShuffled, setData] = useState(data);
  const [isResultsDisplay, setResultsDisplay] = useState(false);
  const RecaptchaRef = useRef();
  const categories = [
    {
      category: "games",
      title: "",
    },
  ];
  const [currentCategory, setCategory] = useState(categories[0].category);
  const [selectedItems, setSelectedItems] = useState({});
  const [currentCategoryIndex, setCategoryIndex] = useState(0);
  const [isThanksModalDisplay, setIsThanksModalDisplay] = useState(false);
  const [isLoaderActive, setisLoaderActive] = useState(false);
  const submitRef = useRef();
  useEffect(() => {
    if (currentCategoryIndex > -1 && currentCategoryIndex < categories.length) {
      window.scrollTo(0, 0);
      virtualPageView(
        window.location.hostname + window.location.pathname + "pick-games",
        `Pick games`
      );
      if (
        selectedItems[categories[currentCategoryIndex].category] &&
        selectedItems[categories[currentCategoryIndex].category].length === 3
      ) {
        setCategoryIndex(currentCategoryIndex);
        setCategory(categories[currentCategoryIndex].category);
        setResultsDisplay(false);
        return;
      }
      setisLoaderActive(true);
      setCategory(categories[currentCategoryIndex].category);
      setTimeout(() => {
        setisLoaderActive(false);
      }, 300);
    } else {
      console.log(selectedItems);
      submitRef.current.scrollIntoView({behavior: 'smooth'});
    }
  }, [currentCategoryIndex]);
  useEffect(() => {
    if(selectedItems.games && selectedItems.games.length === 3){
      submitRef.current.scrollIntoView();
    }
  }, [selectedItems])
  const setItem = (item, e, specificCategory, specificCategoryIndex) => {
    if (e && e.target.className.indexOf("play") > -1) return;
    let selectedItemsClone = { ...selectedItems };
    let category = specificCategory || currentCategory;
    let categoryIndex = specificCategoryIndex || currentCategoryIndex;
    let currentItems = selectedItemsClone[category];
    if (currentItems) {
      if (currentItems.some((x) => x.id === item.id)) {
        selectedItemsClone[category] = currentItems.filter(
          (x) => x.id !== item.id
        );
      } else if (currentItems.length <= 2) {
        selectedItemsClone[category] = [...currentItems, item];
      }
      if (selectedItemsClone[category].length === 3) {
        setCategoryIndex(-1);
        setSelectedItems({ ...selectedItems, item });
        //send lead
        // setResultsDisplay(true);
      }
    } else {
      selectedItemsClone[category] = [item];
    }

    setSelectedItems(selectedItemsClone);
  };

  useEffect(() => {
    if (typeof data !== "undefined" && !isDataShuffled) {
      setData(getShuffleData(data));
      setisDataShuffled(true);
    }
  }, [isDataShuffled]);
  useEffect(() => {
    window.pressedSubmit = pressedSubmit;
  }, [])
  
  
  const pressedSubmit = (token) => {
    localStorage.setItem("voted", "true");
    sendVote(selectedItems, token);
    GA_Event("GA_Event", "Vote", "Games", selectedItems.games[0].name)
    GA_Event("GA_Event", "Vote", "Games", selectedItems.games[1].name)
    GA_Event("GA_Event", "Vote", "Games", selectedItems.games[2].name)
    setResultsDisplay(true);
  };

  return (
    <>
    {!isResultsDisplay &&
      <Header
        setPageSection={props.setPageSection}
        isResultsDisplay={isResultsDisplay}
        currentCategoryIndex={currentCategoryIndex}
        isResultsDisplay={isResultsDisplay}
        categories={categories}
        currentCategory={currentCategory}
        selectedItems={selectedItems}
        setCategory={setCategoryIndex}
        categoryIndex={currentCategoryIndex}
        class="fixed"
      />
  }
      <Loader active={isLoaderActive} />
      <div className={`votes-container ${isResultsDisplay ? "hide" : ""}`}>
        {/* <ReCAPTCHA ref={saveButtonCaptchaRef} sitekey={"6LfoC3kUAAAAAPt8XZMzr6ljG2omdMJY7z8PPhpU"} onChange={postData} size="invisible"/> */}

        {isDataShuffled === true && !isResultsDisplay ? (
          <>
          <Items
            categoryIndex={currentCategoryIndex}
            setItem={setItem}
            selectedItems={selectedItems}
            currentCategory={currentCategory}
            data={dataShuffled}
          />
          <button className="button-submit"
          ref={submitRef}
          onClick={() => RecaptchaRef.current.execute()}>סיימתי להצביע</button>
          <ReCAPTCHA 
          ref={RecaptchaRef}
          size="invisible"
          onChange={pressedSubmit}
          sitekey="6LfoC3kUAAAAAPt8XZMzr6ljG2omdMJY7z8PPhpU"
          />
          </>
        ) : isResultsDisplay ? (
          <>
            {isThanksModalDisplay ? (
              <>
                <ThanksModal
                  onClickHandle={() => props.setPageSection("home")}
                />
                <Items
                  categoryIndex={currentCategoryIndex}
                  setItem={setItem}
                  selectedItems={selectedItems}
                  currentCategory={currentCategory}
                  data={dataShuffled}
                />
              </>
            ) : (
              ""
            )}
            <div className="bg"></div>
            <ThanksModal
              onClickHandle={() => {
                props.setPageSection("home");
              }}
              setPageSection={props.setPageSection}
            />
          </>
        ) : (
          ""
        )}
      </div>
    </>
  );
};

export default Votes;
